import { SCROLL_PROGRESS_BAR_WIDTH, SIDEBAR_WIDTH } from '@/map/map-constants';
import styled from 'styled-components';

export const MapContainerWrapper = styled.div`
  height: 100%;
`;

export const VisibilityToggleWrap = styled.div`
  height: 24px;
  width: 24px;
  border: 1px solid lightgray;
  position: absolute;
  left: ${(props) =>
    props.isSidebarHidden
      ? 0
      : `${SIDEBAR_WIDTH + SCROLL_PROGRESS_BAR_WIDTH}px`};
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${(props) =>
    props.isSidebarHidden ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: all 0.3s ease-in;
  z-index: 1;
  margin-left: 6px;
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  cursor: pointer;
`;

export const InsertMapHere = styled.div`
  width: 100%;
  height: 100%;
  .mapboxgl-canvas {
    z-index: 0;
  }
`;

export const MapContainerLayout = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  overflow: hidden;

  .mapboxgl-popup {
    z-index: 2;
  }

  .mapboxgl-ctrl-bottom-right {
    z-index: unset;
  }

  .mapboxgl-popup-content {
    width: 308px;
    background: none;
    padding: 0;
  }

  .mapboxgl-ctrl-bottom-left .mapboxgl-ctrl {
    margin: 0 0 4px 22px;
  }

  .mapboxgl-ctrl-bottom-left .mapboxgl-ctrl a.mapboxgl-ctrl-logo {
    width: 72px;
    height: 18px;
  }

  .mapboxgl-ctrl.mapboxgl-ctrl-group {
    margin-bottom: 20px;
    margin-right: 20px;
    width: 32px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
    background-color: rgba(16, 25, 56, 0.5);

    button:focus {
      box-shadow: unset;
    }
  }

  .mapboxgl-ctrl-hideable-button-group > button {
    width: 32px;
    height: 32px;
    margin: 0;
    :hover {
      background-color: rgba(16, 25, 56, 0.85);
    }
  }

  .mapboxgl-ctrl-icon.mapboxgl-ctrl-zoom-in {
    margin-left: 1px;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath style='fill:%23ffffff;' d='M 10 6 C 9.446 6 9 6.4459904 9 7 L 9 9 L 7 9 C 6.446 9 6 9.446 6 10 C 6 10.554 6.446 11 7 11 L 9 11 L 9 13 C 9 13.55401 9.446 14 10 14 C 10.554 14 11 13.55401 11 13 L 11 11 L 13 11 C 13.554 11 14 10.554 14 10 C 14 9.446 13.554 9 13 9 L 11 9 L 11 7 C 11 6.4459904 10.554 6 10 6 z'/%3E %3C/svg%3E");
    border-top: 1px solid #ddd;

    :hover {
      background-color: rgba(16, 25, 56, 0.85);
    }
  }

  .mapboxgl-ctrl-icon.mapboxgl-ctrl-zoom-out {
    margin-left: 1px;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath style='fill:%23ffffff;' d='m 7,9 c -0.554,0 -1,0.446 -1,1 0,0.554 0.446,1 1,1 l 6,0 c 0.554,0 1,-0.446 1,-1 0,-0.554 -0.446,-1 -1,-1 z'/%3E %3C/svg%3E");

    :hover {
      background-color: rgba(16, 25, 56, 0.85);
    }
  }

  .mapboxgl-ctrl-icon.mapboxgl-ctrl-compass {
    margin-left: 1px;

    :hover {
      background-color: rgba(16, 25, 56, 0.85);
      margin-left: 0px;
      width: 100%;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  .mapboxgl-ctrl-icon.mapboxgl-ctrl-compass > .mapboxgl-ctrl-compass-arrow {
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpolygon fill='%23ffffff' points='6,9 10,1 14,9'/%3E %3Cpolygon fill='%23CCCCCC' points='6,11 10,19 14,11 '/%3E %3C/svg%3E");
  }

  #map-info-button {
    height: 32px;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
    background-color: rgba(16, 25, 56, 0.5);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23FFF' d='M7.304 5.964h1.339V4.625h-1.34v1.34zm0 5.357h1.339V6.768h-1.34v4.553zm.67-10.178c-1.825 0-3.54.71-4.83 2S1.142 6.15 1.142 7.973c0 3.767 3.064 6.83 6.83 6.83h.001c1.824 0 3.54-.71 4.83-2 1.289-1.29 2-3.005 2-4.83 0-3.766-3.064-6.83-6.83-6.83zm3.92 10.75c-1.038 1.043-2.449 1.627-3.92 1.623-3.057 0-5.544-2.486-5.544-5.543-.004-1.47.58-2.882 1.623-3.92 1.038-1.042 2.45-1.627 3.92-1.623 3.056 0 5.544 2.487 5.544 5.543.004 1.471-.581 2.883-1.624 3.92z'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: center;

    :focus {
      border-radius: 0px;
    }
  }
`;

export const FilterInputs = styled.div`
  width: ${(props) =>
    props.isSidebarHidden || props.printMode ? '0px' : `${SIDEBAR_WIDTH}px`};
  height: 100%;
  overflow-y: scroll;
  overflow-x: visible;
  display: block;
  transition: width 0.2s ease-in;
  background-color: rgb(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  box-shadow: 2px 0 20px 0 rgba(184, 195, 212, 0.25);
  z-index: 2;

  ::-webkit-scrollbar {
    display: none;
    overflow-y: auto;
  }
`;

export const ScrollProgressContainer = styled.div`
  height: 100%;
`;

export const ScrollProgressBar = styled.div`
  width: ${(props) =>
    props.isSidebarHidden ? 0 : `${SCROLL_PROGRESS_BAR_WIDTH}px`};
  background: #37a3bc;
  height: 0%;
  transition: height 0.1s linear;
  opacity: 0.85;
  backdrop-filter: blur(10px);
  z-index: 2;
`;

export const TagWrapper = styled.div`
  z-index: 1;
  position: absolute;
  left: 10px;
  top: 10px;
  transition: left 0.5s ease-in;
  width: calc(100% - 20px);

  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;
